// extracted by mini-css-extract-plugin
export default {"productImage":"product-image_productImage__1OLeX","tag":"product-image_tag__1adBx"};